import React, { cloneElement } from "react";
import "../../styles/Project.css";
const ToggleTag = ({
  title,
  id,
  lblClass = "h-7 xl:h-8 ",
  containerClass = "",
  checked,
  onChange,
  Icon,
  compact = false,
}) => {
  return (
    <div className={`${containerClass} `}>
      <input
        type="checkbox"
        id={id}
        className="appearance-none hidden w-full h-full toggle-tag  "
        onChange={onChange}
        checked={checked}
      />
      <label
        htmlFor={id}
        className={`flex items-center font-semibold
              w-full ${compact ? 'h-7' : lblClass} bg-transparent cursor-pointer toggle-tag-label transition-all duration-300 rounded-full overflow-hidden ${compact ? 'pr-3 pl-1' : 'pr-4 pl-1'} hover:shadow-md`}
      >
        <span className={`${compact ? 'min-w-[22px] min-h-[22px] w-[22px] h-[22px]' : 'min-w-[28px] min-h-[28px] w-[28px] h-[28px] xl:w-9 xl:h-9'} flex justify-center items-center rounded-full bg-gradient-to-br from-[#1F163B] to-[#2d2451] mr-2 shadow-md`}>
          {cloneElement(Icon, {
            size: compact ? 12 : 18,
            color: "#F4D9FF",
          })}
        </span>
        <span className={compact ? "text-xs whitespace-nowrap" : "text-sm xl:text-base"}>{title}</span>
      </label>
    </div>
  );
};

export default ToggleTag;
